import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { IRatingData } from "../ratings/get-ratings.handler";
import { IAssetsState } from ".";

interface IGetAssetsResponse {
    ratings: IRatingData[];
    collectionsCount: number;
    boostsCount: number;
    achievementsCount: number;
}

export const getAssets = createAsyncThunk<IGetAssetsResponse>(
    'getAssets',
    async () => await api.assets.getAssets()
);

const getAssetsHandler = (builder: ActionReducerMapBuilder<IAssetsState>) => {
    builder
        .addCase(getAssets.pending, (state: IAssetsState) => {
            state.loading = true;
            state.error = "";
        })
        .addCase(getAssets.fulfilled, (state: IAssetsState, action: PayloadAction<IGetAssetsResponse>) => {
            state.loading = false;

            if (!action.payload)
                return;

            state.ratings = action.payload.ratings;
            state.collectionsCount = action.payload.collectionsCount;
            state.boostsCount = action.payload.boostsCount;
            state.achievementsCount = action.payload.achievementsCount;
        })
        .addCase(getAssets.rejected, (state: IAssetsState) => {
            state.loading = false;
            state.error = 'Unable to get assets';
        });
};

export default getAssetsHandler;